<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印调拨单"
      width="900px"
      class="printOutStockOrder">
    <div id="printProductionPicking" :loading="contentLoading">
      <div v-for="(item, index) in outStockBillVOS" :key="index" style="page-break-before: always;margin-bottom:10px;">
        <table class="codeBox" cellspacing="0" style="width:100%">
          <tr>
            <td rowspan="6" style="padding:5px">
              <div :id="'qrCode' + item.billNo" align="center"/>
            </td>
            <td colspan="6" style="text-align: center; font-weight: 700; font-size: 16px">调拨单</td>
          </tr>
          <tr>
            <td colspan="3">领料仓</td>
            <td>要求日期</td>
            <td colspan="2">{{item.requireDate}}</td>
          </tr>
          <tr>
            <td colspan="3">{{item.destWarehouseName}}</td>
            <td style="width:80px;"/>
            <td style="width:90px;">绕制</td>
            <td style="width:90px;">组装</td>
          </tr>
          <tr>
            <td colspan="2">制单时间</td>
            <td>领料单号</td>
            <td>工位</td>
            <td>{{item.workUnit1}}</td>
            <td>{{item.workUnit2}}</td>
          </tr>
          <tr>
            <td colspan="2">{{item.createTime}}</td>
            <td>{{item.billNo}}</td>
            <td>物料情况</td>
            <td colspan="2">{{item.purchaseStatus}}</td>
          </tr>
<!--          <tr>-->
<!--            <td>客户名称</td>-->
<!--            <td>数量</td>-->
<!--            <td>关联单号</td>-->
<!--            <td/>-->
<!--            <td/>-->
<!--            <td/>-->
<!--          </tr>-->
<!--          <tr>-->
<!--            <td>{{item.customerName}}</td>-->
<!--            <td>{{item.productQuantity}}</td>-->
<!--            <td>{{item.relBillNo}}</td>-->
<!--            <td colspan="3"/>-->
<!--          </tr>-->
          <tr>
            <td>备注</td>
            <td colspan="5">{{item.note}}</td>
          </tr>
        </table>
        <table class="codeBox" cellspacing="0" style="width:100%">
          <tr>
            <td style="width:150px;">物料编号</td>
            <td>规格型号</td>
            <td colspan="3">物料名称</td>
            <td style="width:10%;text-align:center;">数量</td>
            <td style="width:10%;text-align:center;">实发数量</td>
            <td>库位</td>
            <td>备注</td>
          </tr>
          <tr v-for="(i,index1) in item.outStockBillDetailVOS" :key="index1" style="height: 10px;">
            <td style="width:150px;">{{i.materialNo}}</td>
            <td>{{i.specification}}</td>
            <td colspan="3">{{i.materialName}}</td>
            <td style="text-align:center;">{{i.quantity}}</td>
            <td/>
            <td>{{i.warehouseAreaName + "[" + i.locationName + "]"}}</td>
            <td>{{i.note}}</td>
          </tr>
        </table>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";

  export default {
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        ids: [],
        outStockBillVOS: [
          {
            billNo: "",
            outStockTypeName: "",
            requireDate: "",
            relBillNo: "",
            note: "",
            workUnit1: "",
            workUnit2: "",
            purchaseDate: "",
            purchaseStatus: "",
            destWarehouseName: "",
            productionOrderNo: "",
            materialNo: "",
            materialName: "",
            customerName: "",
            productQuantity: "",
            deliveryDate: "",
            specification: "",
            outStockBillDetailVOS: [],
          },
        ],
      };
    },

    methods: {
      open(ids) {
        this.dialogVisible = true;
        this.getData(ids);
        this.ids = ids;
      },

      getData(ids) {
        this.contentLoading = true;
        this.$http.get("basic", `outStockBills/getAllListByIds1/${ids}`).then((resp) => {
          this.outStockBillVOS = resp.data;
          for (let item of this.outStockBillVOS) {
            item.destWarehouseName = item.outStockBillDetailVOS[0].destWarehouseAreaName + "[" + item.outStockBillDetailVOS[0].destLocationName + "]";
            this.$nextTick(() => {
              document.getElementById("qrCode" + item.billNo).innerHTML = "";
              this.bindQRCode(item.billNo);
            });
          }
          this.contentLoading = false;
        });
      },

      bindQRCode(billNo) {
        let text = billNo;
        new QRCode(document.getElementById("qrCode" + billNo), {
          text: text,
          width: 120,
          height: 120,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },

      print() {
        this.$nextTick(() => {
          document.body.innerHTML = document.getElementById("printProductionPicking").parentNode.innerHTML;
          window.print();
          window.location.reload();

          this.$http.post("basic", "outStockProductions/updatePrint", this.ids).then(() => {
          });
          return false;
        });

      },
    },
  };
</script>

<style scoped>
/* 正文样式 */
table {
  width: 100%;
  height: 20px;
  font-size: 14px;
}

table td {
  border: 1px solid #111;
  border-right: 0;
  border-top: 0;
  padding: 0 5px;
  height: 25px;
}

table tr td:last-child {
  border-right: 1px solid #111;
}

table tr:first-child td {
  border-top: 1px solid #111;
}
</style>

<style>
.printOutStockOrder .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.printOutStockOrder .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.printOutStockOrder .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.printOutStockOrder .el-divider--horizontal {
  margin: 10px 0;
}

.printOutStockOrder .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>